import React from 'react'
import farmerIcon from 'assets/svg/bulk-enrollment-farmer.svg'
import farmerCommittedIcon from 'assets/svg/bulk-enrollment-farmer-committed.svg'

type BulkEnrollmentFarmerIconProps = {
    committed?: boolean
}

export const BulkEnrollmentFarmerIcon = ({
    committed = false
}: BulkEnrollmentFarmerIconProps) => (
    <span
        className={`bulk-enrollment-farmer-icon ${
            committed ? 'bulk-enrollment-farmer-icon--committed' : ''
        }`}
        aria-hidden="true"
    >
        <img
            src={committed ? farmerCommittedIcon : farmerIcon}
            alt=""
            width={40}
            height={40}
        />
    </span>
)
